export const isMobileSize = () => innerWidth < 0x400;
export const isPortrait = () => innerWidth < innerHeight;
export const isLandscape = () => innerHeight < innerWidth;

export const isMobile = () => isAndroid || isIOS || isTablet;
export const isAndroid = /(android)/i.test(navigator.userAgent);
export const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

export const isDesktopSafari = !!(window as Application).safari;
export const isSafari = isIOS || isDesktopSafari;
export const isMobileSafari =
  navigator.userAgent.indexOf('Safari') > -1 &&
  navigator.userAgent.indexOf('Chrome') === -1;

export const isTablet =
  /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
    navigator.userAgent.toLowerCase()
  );

export const getFrameRate = (steps = 10): Promise<number> =>
  new Promise((resolve) => {
    const times: number[] = [];

    const callback = (time: number) => {
      times.unshift(time);

      if (times.length > steps) {
        const fps = ((1e3 * steps) / (time - times.pop()!)) | 0;
        return ~cancelAnimationFrame(raf) && resolve(fps);
      }

      raf = requestAnimationFrame(callback);
    };

    let raf = requestAnimationFrame(callback);
  });
